/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;flex-flow:column;min-height:100%;overflow:auto}[_nghost-%COMP%]   .child[_ngcontent-%COMP%]{height:var(--app-height);position:relative}.child[_ngcontent-%COMP%]{transition:-webkit-filter .25s ease;transition:filter .25s ease;transition:filter .25s ease,-webkit-filter .25s ease}.child--blured[_ngcontent-%COMP%]{-webkit-filter:blur(4px);filter:blur(4px)}"];
export { styles as styles };
